import { render, staticRenderFns } from "./LedgersPage.vue?vue&type=template&id=6da745b6&scoped=true"
import script from "./LedgersPage.vue?vue&type=script&lang=js"
export * from "./LedgersPage.vue?vue&type=script&lang=js"
import style0 from "./LedgersPage.vue?vue&type=style&index=0&id=6da745b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da745b6",
  null
  
)

export default component.exports